// ============================================
// EXISTING VISA TREE VIEW — LAYOUT CONSTANTS
// ============================================
// All tuneable values for the decision-tree canvas.
// Import from here; treeLayoutEngine.js contains only functions.

// ============================================
// NODE GEOMETRY
// ============================================

export const NODE_WIDTH = 280;              // px — fixed width of every node card
export const NODE_MIN_HEIGHT = 100;         // px — floor: no node is ever rendered shorter than this
export const NODE_MAX_HEIGHT = 160;         // px — soft ceiling before the preview button bonus (effective max = NODE_MAX_HEIGHT + PREVIEW_BUTTON_HEIGHT)
export const NODE_PADDING = 14;             // px — internal horizontal padding inside the node card
export const HEADER_HEIGHT = 36;            // px — height of the coloured type-indicator header bar
export const PREVIEW_BUTTON_HEIGHT = 36;    // px — space reserved for the preview button row (24px button + 12px margin)

// ============================================
// TREE LAYOUT SPACING
// ============================================

export const LEVEL_HEIGHT = 220;            // px — vertical distance between a parent row and its children's row
export const MIN_NODE_GAP = 50;             // px — minimum horizontal gap enforced between any two sibling nodes
export const SUBTREE_GAP = 70;              // px — minimum horizontal gap between the bounding boxes of adjacent subtrees
export const TREE_PADDING = 40;             // px — canvas margin: shifts the whole tree away from the left edge and is included in bounds

// ============================================
// EDGE ROUTING
// ============================================

export const LABEL_HEIGHT = 24;             // px — height of an edge label box; used as the vertical stacking offset when labels collide
export const ARROW_SIZE = 10;               // px — length of the arrowhead drawn at the edge endpoint
export const EDGE_TO_NODE_GAP = 30;         // px — minimum vertical clearance between an edge line and a node bounding box
export const MIN_EDGE_TO_EDGE_GAP = 50;     // px — minimum vertical separation between parallel routing channels under the same parent
export const MIN_ROUTING_ZONE_HEIGHT = 50;  // px — minimum height of the routing zone between parent bottom and child top
export const MIN_CHILD_BELOW_PARENT = 40;   // px — if minChildY is closer than this to parentBottom, force a wider gap
export const FORCED_CHILD_BELOW_OFFSET = 60; // px — forced minChildY distance below parentBottom when the gap is too narrow
export const EFFECTIVE_CHILD_TOP_BUFFER = 50; // px — minimum distance below parentBottom used as the effective child top for channel clamping

// ============================================
// LABEL PLACEMENT
// ============================================

export const LABEL_HALF_HEIGHT = 12;        // px — half-height of a label rectangle used for AABB overlap detection
export const MIN_LABEL_WIDTH = 55;          // px — minimum label box width before the text-length-based calculation takes over
export const LABEL_VERTICAL_LINE_OFFSET = 8; // px — extra horizontal nudge to position a label beside (not on top of) a vertical edge line
export const LABEL_GRID_X = 35;             // px — horizontal cell size of the label occupancy grid (used to deduplicate same-position labels)
export const LABEL_GRID_Y = 20;             // px — vertical cell size of the label occupancy grid
export const LABEL_COLLISION_PAD = 4;       // px — extra vertical gap inserted between vertically stacked colliding labels

// ============================================
// TEXT RENDERING
// ============================================

export const TITLE_FONT_SIZE = 14;          // px — font-size of the node title text
export const TEXT_FONT_SIZE = 13;           // px — font-size of the node body text
export const LINE_HEIGHT = 1.4;             // ×  — line-height multiplier applied when computing text block pixel heights
export const CHARS_PER_LINE = 34;           // chars — maximum characters per line before text wraps

// ============================================
// ALGORITHM LIMITS
// ============================================

export const MAX_COLLISION_ITERATIONS = 15; // passes — collision resolution runs until stable or this cap (empirical: 95% of trees converge in <5 passes)
export const VERTICAL_ALIGN_THRESHOLD = 10; // px — nodes whose centres differ horizontally by less than this are treated as vertically aligned (straight edge)
